
import { defineComponent, onMounted, ref } from 'vue';
import { UserUtils } from '@/models/User';
import { Utils, WechatUtils } from '@/models/Utils';
import { Notify } from 'vant';
import { useRoute } from 'vue-router';
import { Store } from "@/store";
import { storeToRefs } from 'pinia';

export default defineComponent({
	setup() {

		const user = ref({ userName: "", password: "" });
		const option = ref({ browserType: "" });
		// const router = useRouter();

		const { token } = storeToRefs(Store());

		option.value.browserType = Utils.GetBrowserInfo();

		const LoginWithBrowser = async () => {
			let message = await UserUtils.Login(user.value.userName, user.value.password);
			if (message)
				Notify({ type: "warning", message: message });
		};
		const LoginWithWechat = async () => { UserUtils.LoginWithWechat(); };

		// 浏览器注册，不需要
		// const Register = async () => { router.push({ name: "Register", params: { browserType: option.value.browserType } }); };

		const route = useRoute();
		if (route.query?.token)
			token.value = <string>route.query.token;

		onMounted(() => {
			WechatUtils.WechatJSAPIConfig();
		});

		return {
			user, option,
			LoginWithBrowser, LoginWithWechat
		};
	}
})
